module.exports = __webpack_public_path__ + "img/asob.6c2ff690.png";